import { Empty } from "antd";
import { useGetPromotionsQuery } from "../../../../app/features/courses/courses.api";
import useError from "../../../../hooks/useError";
import PromotionCard from "./PromotionCard";

export default function PromotionList() {
  const { data, isLoading, error } = useGetPromotionsQuery({
    activeOnly: true,
    hasCode: true,
    limit: 20,
  });

  useError(error, "ডিসকাউন্ট লোড করা যায়নি");

  const promotions = data?.items || [];

  if (isLoading) {
    return (
      <section>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className="rounded-2xl border border-theme-zinc-200 bg-white p-6 space-y-4 animate-pulse"
            >
              <div className="h-4 w-32 bg-theme-zinc-200 rounded-full" />
              <div className="h-10 w-40 bg-theme-zinc-200 rounded-full" />
              <div className="h-4 w-24 bg-theme-zinc-200 rounded-full" />
              <div className="flex justify-between gap-4">
                <div className="flex-1 h-10 bg-theme-zinc-200 rounded-xl" />
                <div className="flex-1 h-10 bg-theme-zinc-200 rounded-xl" />
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section>
      <div className="grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 gap-6">
        {promotions.length ? (
          promotions.map((promotion) => (
            <PromotionCard key={promotion.id} promotion={promotion} />
          ))
        ) : (
          <div className="lg:col-span-3 md:col-span-2 py-8">
            <Empty description="কোনো ডিসকাউন্ট পাওয়া যায়নি" />
          </div>
        )}
      </div>
    </section>
  );
}
